import { Control, FieldErrors, FieldValues } from "react-hook-form";
import { ClasePoliticaEnum } from "../../schema/request-policies.schema";
import { Field, GridItem, Text } from "@chakra-ui/react";
import { InputCurrency } from "@/components/input-currency/InputCurrency";

interface Props {
  clase: ClasePoliticaEnum[];
  errors: FieldErrors<FieldValues>;
  control: Control<FieldValues>;
  loading?: boolean;
}

export const PolicyAmountInputView = ({
  clase,
  control,
  errors,
  loading,
}: Props) => {
  if (clase?.[0]?.startsWith(ClasePoliticaEnum.TopeDiario) || clase?.[0].startsWith(ClasePoliticaEnum.TopeChequesRespaldo))
    return (
      <GridItem paddingX="16px" paddingY="8px">
        <Field.Root invalid={!!errors?.monto?.message}>
          <Field.Label>
            <Text fontSize="16px" fontWeight={600}>
              Monto
            </Text>
          </Field.Label>
          <InputCurrency
            control={control}
            name="monto"
            height="40px"
            maxLength={20}
            disabled={loading}
          />

          <Field.ErrorText>
            {typeof errors?.monto?.message === "string" ? errors.monto.message : ""}
          </Field.ErrorText>
        </Field.Root>
      </GridItem>
    );
};
